import audioCacheService from '../../service/audio-cache-service';
import { queryClient } from '../../lib/query-client';

export const actionsAlpha = ({ set, get }) => ({
    // Deprecated - React Query handles loading state
    setAsyncRequest:   () => {
        // No-op - kept for backward compatibility
    },
    unsetAsyncRequest: () => {
        // No-op - kept for backward compatibility
    },
});

export const actionsBeta = ({ set, get }) => ({
    setAuthData: ({ userData, token }) => {
        set('token', token);
        set('userData', userData);
    },
    doLogout: () => {
        // Revoke cached audio URLs
        const cachedAudioUrls = get('cachedAudioUrls');
        Object.values(cachedAudioUrls).forEach(url => URL.revokeObjectURL(url));

        // Clear audio cache
        audioCacheService.clearAllCache();

        set('token', '');
        set('userData', {});
        // Clear all React Query cache on logout
        queryClient.clear();
    },
});
